import { FormSection } from './organisms/FormSection/FormSection'
import { HeaderSection } from './organisms/HeaderSection'

const SalePage = () => {
	return (
		<>
			<HeaderSection />
			<FormSection />
		</>
	)
}

export default SalePage
